import axios from "axios";
import store from "../store";
axios.interceptors.request.use(
    (config) => {
        const token = axios.defaults.headers.common.Authorization;
        if (token) {
            config.headers.Authorization = token; // Explicitly set it
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            if (error.response.status === 401) {
                store.dispatch({
                    type: "AUTH_LOGOUT",
                });
            }
            if (error.response.status === 500) {
                console.error("Internal Server Error:", error.response.data);
                // Optionally, show a notification or message to the user
            }
        } else {
            // Handle network or other unexpected errors
            console.error("Network Error:", error.message);
        }
        return Promise.reject(error);
    }
);
export default axios;
